import { render, staticRenderFns } from "./SettingProfile.vue?vue&type=template&id=f77f99ec&scoped=true&"
import script from "./SettingProfile.vue?vue&type=script&lang=ts&"
export * from "./SettingProfile.vue?vue&type=script&lang=ts&"
import style0 from "./SettingProfile.vue?vue&type=style&index=0&id=f77f99ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77f99ec",
  null
  
)

export default component.exports